import React from "react";
import Image from "../../HTMLEntities/Image";
import {
    UniversityLogo,
    TopHeading,
    Content,
    LogoBlurImage,
    ContentTopHeadImage,
    ContentUl,
} from "./Styled";
import {TopHeadingData} from "../../../containers/RegistrationLoginPage/types";
import {prependDomainToImageUrl} from "../../../utils/image";
import {useLocation} from "react-router";
import {getPageType} from "../../../containers/RegistrationLoginPage/utils";
import {validateField} from "../../../utils/validation";

interface Props {
    headingData: TopHeadingData;
}

const TopSection: React.FC<Props> = ({headingData}: Props) => {
    const location = useLocation();
    const {pathname} = location;
    const {pageStatus} = getPageType(pathname);
    const {isSignUp, isMMP} = pageStatus;
    let {headerImage} = headingData;
    headerImage = headerImage && prependDomainToImageUrl(headerImage);
    const description = headingData.description;
    const descriptionArray = description?.split("|");
    return (
        <TopHeading>
            {headingData.headerImage && (
                <UniversityLogo>
                    <LogoBlurImage url={headerImage} />
                    <Image src={headerImage} alt="" />
                </UniversityLogo>
            )}
            {isSignUp && <ContentTopHeadImage />}
            <Content isMMP={isMMP} headerImagePresent={!!headerImage}>
                <h1>{headingData.heading}</h1>
                {isMMP && (
                    <ContentUl>
                        {validateField(descriptionArray) &&
                            descriptionArray.map((data, index) => {
                                return <li key={`headingText_${index}`}>{data}</li>;
                            })}
                    </ContentUl>
                )}

                {!isMMP && headingData.description && <span>{headingData.description}</span>}
            </Content>
        </TopHeading>
    );
};
export default TopSection;
